import * as fromDatatype from '../datatype-library/index';

export interface bl_fi_mst_coupon_line_scan_event_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  hdr_guid: fromDatatype.GuidDataFieldInterface;
  line_guid: fromDatatype.GuidDataFieldInterface;
  namespace: fromDatatype.NamespaceDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  conditional_filter_json: fromDatatype.JsonDatatypeInterface;
  coupon_type: fromDatatype.VarcharDatatypeInterface;
  code: fromDatatype.VarcharDatatypeInterface;
  name: fromDatatype.VarcharDatatypeInterface;
  usage_json: fromDatatype.JsonDatatypeInterface;
  pricing_bundle_json: fromDatatype.JsonDatatypeInterface;
  payment_logic_json: fromDatatype.JsonDatatypeInterface;
  descr: fromDatatype.TextDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  serial_number: fromDatatype.VarcharDatatypeInterface;
  entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  assignment_date: fromDatatype.TimestampTzDatatypeInterface;
  membership_hdr_guid: fromDatatype.GuidDataFieldInterface;
  subject_guid: fromDatatype.GuidDataFieldInterface;
  softpin: fromDatatype.VarcharDatatypeInterface;
  validity_status: fromDatatype.VarcharDatatypeInterface;
  assignment_status: fromDatatype.VarcharDatatypeInterface;
  redemption_status: fromDatatype.VarcharDatatypeInterface;
  redeemable_date_from: fromDatatype.TimestampTzDatatypeInterface;
  redeemable_date_to: fromDatatype.TimestampTzDatatypeInterface;
  cancellation_status: fromDatatype.VarcharDatatypeInterface;
  source: fromDatatype.VarcharDatatypeInterface;
  activation_pin: fromDatatype.VarcharDatatypeInterface;
  url_key: fromDatatype.VarcharDatatypeInterface;
  txn_type: fromDatatype.VarcharDatatypeInterface;
  obj_action: fromDatatype.VarcharDatatypeInterface;
  event_code: fromDatatype.VarcharDatatypeInterface;
}

export class bl_fi_mst_coupon_line_scan_event_RowClass
  implements bl_fi_mst_coupon_line_scan_event_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    hdr_guid: fromDatatype.GuidDataFieldInterface;
    line_guid: fromDatatype.GuidDataFieldInterface;
    namespace: fromDatatype.NamespaceDataFieldInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    conditional_filter_json: fromDatatype.JsonDatatypeInterface;
    coupon_type: fromDatatype.VarcharDatatypeInterface;
    code: fromDatatype.VarcharDatatypeInterface;
    name: fromDatatype.VarcharDatatypeInterface;
    usage_json: fromDatatype.JsonDatatypeInterface;
    pricing_bundle_json: fromDatatype.JsonDatatypeInterface;
    payment_logic_json: fromDatatype.JsonDatatypeInterface;
    descr: fromDatatype.TextDatatypeInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    status: fromDatatype.StatusDataFieldInterface;
    revision: fromDatatype.RevisionDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
    serial_number: fromDatatype.VarcharDatatypeInterface;
    entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
    assignment_date: fromDatatype.TimestampTzDatatypeInterface;
    membership_hdr_guid: fromDatatype.GuidDataFieldInterface;
    subject_guid: fromDatatype.GuidDataFieldInterface;
    softpin: fromDatatype.VarcharDatatypeInterface;
    validity_status: fromDatatype.VarcharDatatypeInterface;
    assignment_status: fromDatatype.VarcharDatatypeInterface;
    redemption_status: fromDatatype.VarcharDatatypeInterface;
    redeemable_date_from: fromDatatype.TimestampTzDatatypeInterface;
    redeemable_date_to: fromDatatype.TimestampTzDatatypeInterface;
    cancellation_status: fromDatatype.VarcharDatatypeInterface;
    source: fromDatatype.VarcharDatatypeInterface;
    activation_pin: fromDatatype.VarcharDatatypeInterface;
    url_key: fromDatatype.VarcharDatatypeInterface;
    txn_type: fromDatatype.VarcharDatatypeInterface;
    obj_action: fromDatatype.VarcharDatatypeInterface;
    event_code: fromDatatype.VarcharDatatypeInterface;
}
